import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var fieldSetComponentName = 'QuantumFieldSet';
export function getFieldSetUtilityClass(slot) {
    return generateUtilityClass(fieldSetComponentName, slot);
}
export var fieldSetClasses = generateUtilityClasses(fieldSetComponentName, [
    'root',
    'labelContent',
    'labelText',
    'descriptionText',
    'contentWrapper',
]);
